import { useState } from 'react';
import * as R from 'ramda';

import { Icon, IconButton } from '@atom/mui';
import {
  CardMembershipIcon,
  DeleteIcon,
  EditIcon,
  GroupIcon,
} from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { UserCertificationItem } from '@atom/types/user';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import AddEditCertModal from './AddEditCertModal';
import DeleteCertModal from './DeleteCertModal';

import classes from './certificationsTab.module.css';

export interface Props {
  certification: UserCertificationItem;
}

const UserCertTile = ({ certification }: Props) => {
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);

  return (
    <>
      <div className={classes.certTile}>
        <div className={classes.certTitleContainer}>
          <Icon color={colors.brand.green} icon={CardMembershipIcon} />
          <div className={classes.certNameContainer}>
            <div className={classes.certName}>{certification.name}</div>
            <div>{certification.description}</div>
            {!R.isNil(certification.groupPath) &&
              !R.isEmpty(certification.groupPath) && (
                <div className={classes.subtextContainer}>
                  <Icon
                    color={colors.neutral.gray}
                    style={{ fontSize: '16px' }}
                    icon={GroupIcon}
                  />
                  <div className={classes.subtext}>
                    {certification.groupPath.join(' / ')}
                  </div>
                </div>
              )}
          </div>
        </div>
        {certification.isEditable && (
          <div>
            {hasRolePermissions(ROLE_SETS.ORG_ADMIN) && (
              <IconButton onClick={() => setOpenEdit(true)}>
                <Icon color={colors.neutral.gray} icon={EditIcon} />
              </IconButton>
            )}
            {hasRolePermissions(ROLE_SETS.ORG_ADMIN) && (
              <IconButton onClick={() => setOpenDelete(true)}>
                <Icon color={colors.neutral.gray} icon={DeleteIcon} />
              </IconButton>
            )}
          </div>
        )}
      </div>
      <AddEditCertModal
        isEdit
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        certification={certification}
      />
      <DeleteCertModal
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        certificationId={certification.id}
      />
    </>
  );
};

export default UserCertTile;
